document.addEventListener("DOMContentLoaded", function () {
  if(document.querySelector(".jdgm-carousel-title")){
    document.querySelector(".jdgm-carousel-title").textContent = "Latest Reviews:"
  }


  
  const calculatorPopup = document.getElementById('calculatorPopup');
  const popupContent = document.querySelector('.calculator-container');
  

  
  calculatorPopup.addEventListener('click', function(event) {
      if (event.target === calculatorPopup) {
          toggleCalculatorPopup();
      }
  });

  // Toggle Popup Function
  function toggleCalculatorPopup() {
    const popup = document.getElementById("calculatorPopup");
    const isOpen = popup.style.display === "block";
    popup.style.display = isOpen ? "none" : "block";
    document.body.classList.toggle("overflow-hidden", !isOpen);
  }

  // Unit Conversion Function
  function convertUnits(value, fromUnit, toUnit) {
    const conversionRates = {
      cm: { cm: 1, in: 0.393701, m: 0.01 },
      in: { cm: 2.54, in: 1, m: 0.0254 },
      m: { cm: 100, in: 39.3701, m: 1 }, // added meter conversion as you're using 'm'
    };
    return value * conversionRates[fromUnit][toUnit];
  }

  // Reset values when recalculating
  if (document.querySelector(".recalculate-btn")) {
    document.querySelector(".recalculate-btn").addEventListener("click", () => {
      document.querySelector("#room-length").value = "";
      document.querySelector("#room-width").value = "";
      document.querySelector("#square-footage").value = "";
      document.getElementById("results").style.display = "none";
      document.querySelector(".calculate-btn").style.display = "block";
    });
  }

  // Event listener for closing the calculator popup
  document
    .querySelectorAll(".closebutton, .help-link, .help-link-pop, .shop-now-button")
    .forEach((button) =>
      button.addEventListener("click", toggleCalculatorPopup)
    );

  // Calculate Function for Results
  document
    .querySelector(".calculate-btn")
    .addEventListener("click", function () {
      const productType = document.getElementById("product").value;
      const length =
        parseFloat(document.getElementById("room-length").value) || 0;
      const width =
        parseFloat(document.getElementById("room-width").value) || 0;
      const squareFootage =
        parseFloat(document.getElementById("square-footage").value) || 0;
      const unit = document.getElementById("measurement").value;

      // Get the buffer value from the selected product's `data-item` attribute
      const buffer = $("#product option:selected").data("value") || 0; // changed 'data-value' to 'data-item'

      // Calculate area to cover based on square footage or length/width
      let areaToCover = calculateAreaToCover(
        squareFootage,
        length,
        width,
        unit,
        buffer / 100
      );

      if (areaToCover === null) {
        alert("Please enter valid values.");
        return;
      }
      displayResults(productType, areaToCover, unit);
    });

  // Function to calculate area to cover
  function calculateAreaToCover(squareFootage, length, width, unit, buffer) {debugger;
    if (squareFootage > 0) {
      return Math.ceil(squareFootage * (1 + buffer));
    } else if (length > 0 && width > 0) {
      // length = convertUnits(length, unit, 'm'); // Convert length and width to meters
      // width = convertUnits(width, unit, 'm');
      return length * width * (1 + buffer);
    }
    return null; // Invalid input, return null
  }

  // Function to display results
  function displayResults(productType, areaToCover, unit) {
    let ac = areaToCover; 
      if(unit == "cm"){
        ac = Math.ceil(areaToCover *  0.01);
      }
      if(unit == "in"){
        ac = Math.ceil(areaToCover * 0.0254)
      }

    
    if (["tiles", "planks"].includes(productType)) {
      let packCoverage =
        parseFloat(
          document.querySelector(".coverage-info").getAttribute("data-coverage")
        ) || 1;
      
      const packages = Math.ceil(ac / packCoverage);
      document.getElementById("packagesResult").style.display = "inline-block";
      document.querySelector(".other-result").classList.remove('center');
      document.getElementById(
        "packagesResult"
      ).innerHTML = `You Need <strong>${packages} ${ packages > 1 ? 'Packages' : 'Package'}</strong>`;
    } else {
      document.getElementById("packagesResult").style.display = "none";
      document.querySelector(".other-result").classList.add('center');
    }
    document.getElementById("toCoverResult").textContent = 
     ac + ' m²';

    document.getElementById("results").style.display = "block";
    document.querySelector(".calculate-btn").style.display = "none";
  }

  // Handle Measurement Unit Change
  const selectMeasurement = document.getElementById("measurement");
  const inputWrapper = document.querySelectorAll(".input-wrapper");
  const inputWrapperfoot = document.querySelectorAll(".wrapper-foot");

  selectMeasurement.addEventListener("change", function () {
    const selectedValue = selectMeasurement.value;
    inputWrapper.forEach((element) => {
      element.setAttribute("data-content", selectedValue);
    });
    inputWrapperfoot.forEach((element) => {
      element.setAttribute("data-content", selectedValue);
    });
  });

  // Scroll to Reviews Section
  document
    .querySelector(".see-all-review a")
    .addEventListener("click", function (event) {
      event.preventDefault();
      const target = document.querySelector("#judgeme_product_reviews");
      target.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const thumbOneElement = document.querySelector(".thumb-one");
  if (thumbOneElement) {
    thumbOneElement.setAttribute("aria-current", "true");
  }
  // Function to handle playing the video
  function playVideo(mediaId) {
    const videoElement = document.querySelector("li[data-media-id] video");

    // Check if the video element exists
    if (videoElement) {
      // Pause all other videos
      const allVideos = document.querySelectorAll("video");
      allVideos.forEach((video) => {
        if (video !== videoElement) {
          video.pause();
          video.currentTime = 0; // Reset the video to the start
        }
      });

      // Play the selected video
      videoElement.play();
    }
  }

  // Add event listener to play video on click
  document
    .querySelectorAll(".thumbnail-list__item .thumbnail")
    .forEach((thumbnail) => {
      thumbnail.addEventListener("click", function () {
        const mediaId = this.closest(".thumbnail-list__item").getAttribute(
          "data-target"
        );
      var element = document.getElementById('Slide-' + mediaId);
      element.scrollIntoView({ behavior: "smooth", block: "nearest" });
                                                       
        playVideo(mediaId);
      });
    });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelector(".notify-me-when-available").addEventListener("click", function (event) {
    event.preventDefault();
    document.querySelector(".back-overlay").classList.add("active");
    document.querySelector("#email_signup").classList.add("active");
  });
  document.querySelector(".top-notify-me-cross").addEventListener("click", function (event) {
    event.preventDefault();
    document.querySelector(".back-overlay").classList.remove("active");
    document.querySelector("#email_signup").classList.remove("active");
  });
   document.querySelector(".back-overlay").addEventListener("click", function (event) {
    event.preventDefault();
    document.querySelector(".back-overlay").classList.remove("active");
    document.querySelector("#email_signup").classList.remove("active");
  });
  if(document.querySelector(".notify-me-when-available") && document.querySelector(".product-form__submit")){
          if(document.querySelector(".product-form__submit").disabled){
            document.querySelector(".notify-me-when-available").classList.add("active");
          }
          else{
            document.querySelector(".notify-me-when-available").classList.remove("active");
          }
        }
});